import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { AlertModal, AlertSuccessModal, Text } from 'components'
import { useAlert, useFilter } from 'store'

import {
  getNotificationBoxTexts,
  getPeriodicityProps,
  getConfirmCheck,
  getIsDisabled,
} from './utils'
/**
 * This component works both for exitModal and regular alert Modal, we decided to build it using a prop (exitModal) and some ternary verifications to simplify implementation, but it could also be implemented abstracting regular AlertContainer implementation and using it both on exitAlertContainer and regularAlertContainer with some custom props.
 * @param {boolean} exitModal Props to define if this alertContainer is related to exit Modal or normal alerta Modal, it will control some of it's child (alertModal) props so that it is works properlly with exitModal or alert Modal. This works similar to an extends on OOP
 * @returns
 * @author Leandro Parisi
 * @since 2021.03.26
 */
const AlertContainer = ({ exitModal }) => {
  const [openAlertSuccess, setOpenAlertSuccess] = React.useState(false)
  const [loadingFetch, setloadingFetch] = React.useState(false)

  const {
    setField,
    fetchAlert,
    clearStateAlert,
    getForm,
    getOpenModal,
    setOpenAlertModal,
    getOpenExitModal,
    setOpenExitModal,
  } = useAlert()

  const {
    $filter,
    setField: setFieldFilter,
    clearFilters,
    toggleFilter,
    removeSelectedLocality,
    setSelectedLocalities,
    setFieldManually,
    setFiltersModal,
    setMaxValueRange,
    setMinValueRange,
  } = useFilter()

  const {
    filtersModal: { openModal },
  } = $filter

  const [innerFilter, setInnerFilter] = useState($filter)
  useEffect(() => setInnerFilter($filter), [$filter])

  const opened = exitModal ? getOpenExitModal() : getOpenModal()
  const closeModal = exitModal ? setOpenExitModal : setOpenAlertModal
  const { periodicity } = getForm()

  const joinFilters = () => {
    const filtersArray = []

    Object.keys(innerFilter).map(filter => {
      const currentFilter = innerFilter[filter]

      if (currentFilter && filter === 'filters') {
        Object.keys(currentFilter).map(checkFilter => {
          const checkFilterOpt = currentFilter[checkFilter]

          if (!Array.isArray(checkFilterOpt)) {
            return null
          }

          checkFilterOpt.map(option => {
            if (option.checked) {
              return filtersArray.push(option.name)
            }
            return null
          })
          return null
        })
      }
      if (filter === 'noDebts' && currentFilter) {
        return filtersArray.push('Sem dívidas')
      }

      if (filter === 'noLegalActions' && currentFilter) {
        return filtersArray.push('Sem ações judiciais')
      }

      if (filter === 'desagio' && currentFilter > 0) {
        return filtersArray.push(
          `Com deságio maior que ${Math.ceil(currentFilter)}%`
        )
      }

      if (filter === 'visits' && currentFilter) {
        return filtersArray.push('Permitido visitas')
      }

      if (filter === 'locality' && currentFilter) {
        return filtersArray.push(currentFilter)
      }

      if (
        filter === 'selectedLocalities' &&
        currentFilter &&
        currentFilter[0]
      ) {
        currentFilter.map(locality => {
          return filtersArray.push(locality.name)
        })
      }

      if (filter === 'valueRange') {
        return filtersArray.push(
          `Com o valor entre R$ ${currentFilter.min.toLocaleString(
            'pt-br'
          )} e R$ ${currentFilter.max.toLocaleString('pt-br')}`
        )
      }

      return null
    })

    return filtersArray.join(', ')
  }

  const handleConfirm = async (values, checkOffers, checkOffersResale) => {
    setloadingFetch(true)
    const success = await fetchAlert(
      values,
      innerFilter,
      checkOffers,
      checkOffersResale
    )
    setloadingFetch(false)

    if (success) {
      closeModal()
      setOpenAlertSuccess(!openAlertSuccess)
      clearStateAlert()
    }
  }

  const handleNewAlert = () => {
    setOpenAlertSuccess(!openAlertSuccess)
    setOpenAlertModal()
  }

  const { title, message } = getNotificationBoxTexts(exitModal)

  const notificationBoxProps = {
    renderTitle: () => {
      return (
        <Text color="whiteColor" fontSize="large">
          <b>{title}</b>
        </Text>
      )
    },

    renderMessage: () => {
      return (
        <Text color="whiteColor" fontSize="medium">
          {message}
        </Text>
      )
    },
  }

  const periodicityProps = exitModal ? null : getPeriodicityProps(periodicity)

  const confirmCheck = exitModal
    ? getConfirmCheck(loadingFetch, getForm())
    : getConfirmCheck(
        loadingFetch,
        getForm(),
        periodicityProps.somePeriodicityChecked
      )

  const isDisabled = exitModal
    ? getIsDisabled(getForm())
    : getIsDisabled(getForm(), periodicityProps.somePeriodicityChecked)

  const openFilterModal = () => {
    setFiltersModal('openModal', !openModal)
    setFiltersModal('showReducedFilters', true)
  }
  return (
    <>
      <AlertModal
        values={getForm()}
        opened={opened}
        closeModal={() => closeModal()}
        createAlert={handleConfirm}
        setField={setField}
        setFieldFilter={setFieldFilter}
        toggleFilter={toggleFilter}
        isLoading={loadingFetch}
        selectedFilter={joinFilters()}
        filter={innerFilter}
        setFilter={setInnerFilter}
        clearFilters={clearFilters}
        removeSelectedLocality={removeSelectedLocality}
        setSelectedLocalities={setSelectedLocalities}
        setFieldManually={setFieldManually}
        notificationBoxProps={notificationBoxProps}
        periodicityProps={periodicityProps}
        confirmCheck={confirmCheck}
        isDisabled={isDisabled}
        openFilterModal={openFilterModal}
        openModal={openModal}
        setMaxValueRange={setMaxValueRange}
        setMinValueRange={setMinValueRange}
      />
      <AlertSuccessModal
        opened={openAlertSuccess}
        closeModal={() => setOpenAlertSuccess(!openAlertSuccess)}
        openAlertModal={handleNewAlert}
      />
    </>
  )
}

AlertContainer.propTypes = {
  exitModal: PropTypes.bool,
}

AlertContainer.defaultProps = {
  exitModal: false,
}

export default React.memo(AlertContainer)
